import { Option, OptionChoice } from "__generated__/graphql";

export const mapOptionChoiceToOption = (choice: OptionChoice): Option => {
  return {
    value: choice.value,
    colour: choice.colour,
    id: choice.id,
    __typename: "Option",
  };
};
